import { Component, ElementRef, EventEmitter, Input, Output } from "@angular/core";
import { Item } from "@common/ADAPT.Common.Model/organisation/item";
import { ItemStatusMetadata } from "@common/ADAPT.Common.Model/organisation/item-status";
import { Link } from "@common/ADAPT.Common.Model/organisation/link";
import { AdaptCommonDialogService } from "@common/ux/adapt-common-dialog/adapt-common-dialog.service";
import { IConfirmationDialogData } from "@common/ux/adapt-common-dialog/confirmation-dialog.component/confirmation-dialog.component";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { MeetingsService } from "@org-common/lib/meetings/meetings.service";
import { filter, switchMap } from "rxjs";

@Component({
    selector: "adapt-display-action-link",
    templateUrl: "./display-action-link.component.html",
    styleUrls: ["../../meetings/meeting-styles.scss", "../../kanban/items/items-styles.scss"],
    standalone: false,
})
export class DisplayActionLinkComponent extends BaseComponent {
    public readonly ItemStatusMetadata = ItemStatusMetadata;

    @Input() public showDeleteLink = false;
    @Input() public link!: Link;
    @Input() public showStatus = true;
    @Input() public itemLinksDisabled = false;
    @Input() public closeAllDialogsOnDelete = true;
    @Output() public itemDialogClosed = new EventEmitter<Item>();

    public constructor(
        private dialogService: AdaptCommonDialogService,
        private meetingsService: MeetingsService,
        elementRef: ElementRef,
    ) {
        super(elementRef);
    }

    public deleteLink() {
        const confirmationDialogData: IConfirmationDialogData = {
            title: `Delete action link`,
            message: `<p>Are you sure you want to delete this action link?</p>
                <p>Note that only the link will be deleted but not the actual action.</p>`,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
        };

        return this.dialogService.openConfirmationDialogWithBoolean(confirmationDialogData).pipe(
            filter((confirmDelete) => !!confirmDelete),
            switchMap(() => this.meetingsService.remove(this.link)),
            switchMap(() => this.meetingsService.saveEntities([this.link])),
            this.takeUntilDestroyed(),
        ).subscribe();
    }
}
